module.exports = __webpack_public_path__ + "static/media/multi.fdcba079.svg";